export class RegistrarApontamentoDto {
    dateStart: string;
    hourStart: string;
    dateEnd: string;
    hourEnd: string;
    tipoDesconto: string;
    regras: string[] = [];
    motivo: string;
    imagens: any;
}